import { ResponseErrorHandling } from "../../../../helper";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getNAICSCodes = () => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.get("/lookups/naics-codes"); 
    const naicsCodes = res.data.data;

    if (naicsCodes) {
      localStorage.setItem("naicsCodes", JSON.stringify(naicsCodes));
    }

    dispatch({
      type: CommonActionTypes.GET_ALL_NAICS_CODES_DATA, 
      payload: naicsCodes,
    });

    return naicsCodes;
  } catch (err) {
    const message =
      err.response?.data?.message || err.message || err.toString();
    ResponseErrorHandling(err.response, dispatch);
    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    return [];
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
